/**
 * authDrawer — Componente per il drawer login.
 *
 * Stato globale in Alpine.store('auth'). Questo componente gestisce
 * lo stato locale del form (campi, toggle password).
 *
 * Uso nel template:
 *   <div x-data="authDrawer">
 */
export function registerAuthDrawer(Alpine) {
    Alpine.data('authDrawer', () => ({
        username: '',
        password: '',
        rememberMe: false,
        showPassword: false,
        oauthLoading: false,

        // OTP
        otpEmail: '',
        otpCode: '',

        submit() {
            if (!this.username.trim() || !this.password) return;
            this.$store.auth.login(this.username.trim(), this.password, this.rememberMe);
        },

        submitOtpRequest() {
            if (!this.otpEmail.trim()) return;
            this.$store.auth.requestOtp(this.otpEmail.trim());
        },

        submitOtpVerify() {
            const code = this.otpCode.replace(/\D/g, '');
            if (code.length !== 6) return;
            this.$store.auth.verifyOtp(code);
        },

        resendOtp() {
            this.otpCode = '';
            this.$store.auth.requestOtp(this.$store.auth.otpEmail);
        },

        reset() {
            this.username = '';
            this.password = '';
            this.rememberMe = false;
            this.showPassword = false;
            this.oauthLoading = false;
            this.otpEmail = '';
            this.otpCode = '';
        },

        loginWithGoogle() {
            const w    = 520;
            const h    = 640;
            const left = Math.round(screen.width / 2 - w / 2);
            const top  = Math.round(screen.height / 2 - h / 2);

            this.oauthLoading = true;
            this.$store.auth.error = '';

            // Passa il cart_token guest al popup così google-start.php lo salva in sessione
            // e ApiClient manderà X-Cart-Token all'API per il merge guest → utente
            let startUrl = `${window.IKOS.oauthBase}/google-start.php`;
            const cartToken = localStorage.getItem('ik_cart_token');
            if (cartToken) {
                startUrl += '?cart_token=' + encodeURIComponent(cartToken);
            }

            const popup = window.open(
                startUrl,
                'oauth-google',
                `width=${w},height=${h},left=${left},top=${top},popup=1`
            );

            // Rileva se il popup viene chiuso senza postMessage (es. utente lo chiude)
            // try/catch necessario: Chrome lancia un warning COOP quando popup ha navigato
            // su origin diversa (es. accounts.google.com) e si tenta di leggere popup.closed
            const pollClose = setInterval(() => {
                try {
                    if (popup && popup.closed) {
                        clearInterval(pollClose);
                        this.oauthLoading = false;
                    }
                } catch (_) {
                    // COOP cross-origin: non possiamo leggere popup.closed, ignoriamo
                }
            }, 500);

            const onMessage = (e) => {
                if (e.origin !== window.location.origin) return;
                clearInterval(pollClose);
                window.removeEventListener('message', onMessage);
                this.oauthLoading = false;

                if (e.data?.type === 'oauth-success') {
                    // Il merge guest → utente è avvenuto, il cart_token guest non serve più
                    localStorage.removeItem('ik_cart_token');
                    const isInline = this.$store.auth.inlineMode
                        || sessionStorage.getItem('ik_checkout_pending') === '1';
                    if (isInline) {
                        sessionStorage.removeItem('ik_checkout_pending');
                        window.IKOS.authToken = e.data.authToken || true;
                        this.$store.auth.isLogged = true;
                        this.$store.auth.user = e.data.user ?? { name: '', surname: '' };
                        this.$store.auth._closeDrawerSilent();
                        // Ri-fetcha carrello e wishlist: il merge backend potrebbe aver aggiunto
                        // corsi pre-esistenti dell'utente a quelli guest
                        Alpine.store('cart').refresh();
                        Alpine.store('checkout').openPreview();
                        Alpine.store('wishlist').refresh();
                    } else {
                        // Segnala che il prossimo page load deve ri-fetchare cart e wishlist
                        sessionStorage.setItem('ik_login_method', 'oauth');
                        sessionStorage.setItem('ik_auth_just_logged', '1');
                        sessionStorage.setItem('ik_wishlist_just_logged', '1');
                        window.location.href = '/dashboard';
                    }

                } else if (e.data?.type === 'oauth-needs-completion') {
                    this.$store.auth.closeDrawer();
                    this.$nextTick(() => {
                        window.dispatchEvent(new CustomEvent('oauth-prefill', {
                            detail: e.data.userData,
                        }));
                    });

                } else if (e.data?.type === 'oauth-error') {
                    this.$store.auth.error = e.data.message || 'Errore accesso con Google.';
                }
            };

            window.addEventListener('message', onMessage);
        },
    }));
}
